import React from 'react';
import { AppComponentsProps } from '../../util/AppComponentsProps';
import PropertiesPage from './PropertiesPage';
import { useTranslation } from 'react-i18next';

export type OwnerPropertiesPageProps = {
  appComponentsProps: AppComponentsProps;
};

export default function OwnerPropertiesPage(
  ownerPropertiesPageProps: OwnerPropertiesPageProps
) {
  const { t } = useTranslation();
  document.title = t('GLOBAL.TITLE');

  return (
    <PropertiesPage
      appComponentsProps={ownerPropertiesPageProps.appComponentsProps}
      owner={true}
    />
  );
}
